var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeContour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "104AA5F8-D08E-4738-B0B0-D3D5E6A197E2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V1-hp-Copy",
    transform: "translate(-25.000000, -102.000000)",
    fill: "#0E3E28",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.262787,102.292803 C37.8302189,101.902399 37.1724645,101.902399 36.7398963,102.292803 L25.3750403,112.549586 C25.1369699,112.764449 25.000758,113.069893 25,113.390585 L25,125.863514 C25,126.491178 25.5088219,127 26.1364856,127 L34.0918849,127 C34.7195485,127 35.2283705,126.491178 35.2283705,125.863514 L35.2283705,120.181086 L39.7743129,120.181086 L39.7743129,125.863514 C39.7743129,126.491178 40.2831348,127 40.9107985,127 L48.8661977,127 C49.4938614,127 50.0026834,126.491178 50.0026834,125.863514 L50.0026834,113.390585 C50.0019254,113.069893 49.8657135,112.764449 49.6276431,112.549586 L38.262787,102.292803 Z M47.7297121,124.727029 L42.0472841,124.727029 L42.0472841,119.044601 C42.0472841,118.416937 41.5384622,117.908115 40.9107985,117.908115 L34.0918849,117.908115 C33.4642212,117.908115 32.9553992,118.416937 32.9553992,119.044601 L32.9553992,124.727029 L27.2729712,124.727029 L27.2729712,113.896321 L37.5013417,104.662375 L47.7297121,113.896321 L47.7297121,124.727029 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeContour);
export default __webpack_public_path__ + "static/media/home-contour.d5ff61bfd073d981e2e6d41b637f94fc.svg";
export { ForwardRef as ReactComponent };